<div class='FileUploadDialog'>
  <div
    (dragover)='dragOverHandler($event)'
    (drop)='dropHandler($event)'
    *ngIf='showDropZone'
    class='FileUploadDialog-drop_zone'>
    <p *ngIf='maxFiles > 1'>Drag one or more files to this Drop Zone ...</p>
    <p *ngIf='maxFiles === 1'>Drag one file to this Drop Zone ...</p>
  </div>
  <p *ngIf='showDropZone' class='text-center my-3'>or...</p>
  <div class='FileUploadDialog-upload_button text-center'>
    <button (click)='onClick()' color='warn' mat-button type='button'>
      <mat-icon>file_upload</mat-icon>
      {{ buttonLabel }}
    </button>
  </div>
  <div class='FileUploadDialog-files mt-3'>
    <ul>
      <li *ngFor='let file of files' class='FileUploadDialog-files-file'>
        <div class='FileUploadDialog-files-file-label'>
          <p class='FileUploadDialog-files-file-label-name mb-0'>
            {{ file.data.name }}
            <span
              *ngIf='!file.isValid'
              class='FileUploadDialog-files-file-label-name-error'
            >This file is not valid and will not be imported!</span
            >
          </p>
          <a
            (click)='cancelFile(file)'
            class='FileUploadDialog-files-file-label-cancel'
            title='Cancel'>
            <mat-icon>clear</mat-icon>
          </a>
        </div>
      </li>
    </ul>
  </div>
  <mat-progress-bar
    *ngIf='uploadProgress'
    [value]='uploadProgress'></mat-progress-bar>
  <div
    *ngIf='files.length > 0 && hasValidFiles() === true'
    class='FileUploadDialog-upload text-center my-3'>
    <app-button
      [Click]='uploadFileButtonProperties.onClick'
      [color]='uploadFileButtonProperties.color'
      [disabled]='uploadInProgress'
      [size]='uploadFileButtonProperties.size'
      [text]='uploadFileButtonProperties.text'></app-button>
  </div>
  <div
    *ngIf='(maxFiles || maxFileSize || !allowMultiple) && showWarnings'
    class='FileUpload-info'>
    <div
      *ngIf='!allowMultiple'
      class="alert alert-{{
        isAllowerFilesLimitReached() ? 'danger' : 'warning'
      }}">
      Note: Maximum <b>1</b> file is allowed!
    </div>
    <div
      *ngIf='allowMultiple && maxFiles'
      class="alert alert-{{
        isAllowerFilesLimitReached() ? 'danger' : 'warning'
      }}">
      Note: Maximum <b>{{ maxFiles }}</b> files are allowed!
    </div>
    <div
      *ngIf='maxFileSize'
      class="alert alert-{{
        hasFileWithMaxFileSizeReached() ? 'danger' : 'warning'
      }}">
      Note: Maximum file size is <b>{{ maxFileSize }}</b>
    </div>
  </div>
  <div
    *ngIf='!showWarnings && customWarning'
  >
    <div [innerHTML]='customWarning' class='alert alert-warning'></div>
  </div>

  <input
    accept='{{ getAcceptedExtensions() }}'
    id='fileUpload'
    multiple='{{ allowMultiple }}'
    name='fileUpload'
    style='display: none'
    type='file' />
</div>
